import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { forwardRefAndName } from "../../../../lib/forwardRefAndName";
import { BaseIcon } from "../../BaseIcon";
export var UiMenuDotsThreeVIcon16Light = forwardRefAndName('UiMenuDotsThreeVIcon16Light', function (props, ref) {
  return /*#__PURE__*/(
    React.createElement(BaseIcon, _extends({
      ref: ref
    }, props), /*#__PURE__*/
    React.createElement("path", {
      d: "M9 4a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M9 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    }), /*#__PURE__*/
    React.createElement("path", {
      d: "M8 13a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
    }))
  );
});